var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-button"},[_c('vs-button',{staticClass:"w-full",class:{ disabled: _vm.disabled },style:(_vm.btnStyle),attrs:{"color":_vm.buttonColor,"type":_vm.type,"text-color":_vm.buttonTextColor,"disabled":_vm.disabled,"icon":_vm.icon},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }